module.exports = __webpack_public_path__ + "img/Ivenak.2433304b.svg";